module.exports = __webpack_public_path__ + "static/img/qrIcon.9373ddf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/callMe/qrIcon.png
// module id = I+Dy
// module chunks = 3